import React, { useContext, useEffect, useState } from "react";
//
import { useSelector, useDispatch } from "react-redux";
import NotifyBasic from "../../common/components/notify/NotifyBasic";
// eslint-disable-next-line import/named
import { clearMessage } from "../../reduxStore/commonSlice";
//

const DURATION = 8000;

const NotifyRedux = () => {
  // store
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const { message } = commonState;
  // local state
  const [open, setOpen] = useState(false);

  //
  useEffect(() => {
    if (message.open) {
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
        dispatch(clearMessage());
      }, message.duration || DURATION);
    }
  }, [message]);

  return (
    <NotifyBasic
      open={open}
      message={message.content}
      type={message.type}
      duration={message.duration || DURATION}
    />
  );
};

export default NotifyRedux;
